import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import formatPrice from '@bwoty-web/price-formatter';
import SingleSlider from './_SingleSlider.js';
import { jsx } from 'react/jsx-runtime';
import useGlobals from '../../hooks/useGlobals.js';

var _excluded = ["uniqueId", "min", "max", "value", "valueLabel", "onChange", "hidden"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var roundUp = function roundUp(value, step) {
  return Math.ceil(value / step) * step;
};
var TJAREBORG_SITEID = 15;
var PriceSlider = function PriceSlider(_ref) {
  var uniqueId = _ref.uniqueId,
    min = _ref.min,
    max = _ref.max,
    value = _ref.value,
    valueLabel = _ref.valueLabel,
    onChange = _ref.onChange,
    hidden = _ref.hidden,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useGlobals = useGlobals(),
    siteId = _useGlobals.siteId;
  if (typeof onChange !== 'function' || typeof min !== 'number' || typeof max !== 'number' || max <= min && typeof max === 'number' && typeof min === 'number') {
    return false;
  }
  var step = 1000;
  var isTjareborg = siteId === TJAREBORG_SITEID;
  if (isTjareborg) {
    step = 100;
  }
  var roundedvalue = value === max ? roundUp(max, step) : value;
  var roundedMax = roundUp(max, step);
  var roundedMin = roundUp(min, step);
  return /*#__PURE__*/jsx(SingleSlider, _objectSpread({
    uniqueId: uniqueId,
    min: roundedMin,
    max: roundedMax,
    value: roundedvalue,
    step: step,
    format: formatPrice,
    valueLabel: valueLabel,
    onChangeComplete: onChange,
    hidden: hidden
  }, rest));
};
PriceSlider.defaultProps = {
  uniqueId: '',
  min: 0,
  max: 0,
  value: 0,
  valueLabel: '',
  onChange: function onChange() {},
  hidden: false
};
var PriceSlider$1 = PriceSlider;

export { PriceSlider$1 as default };
//# sourceMappingURL=PriceSlider.js.map
